import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

const INITIAL_TIMER = 60;

export const useStore = create(
  subscribeWithSelector((set) => ({
    gameOver: false,
    setGameOver: (gameOver) => set({ gameOver }),

    heldPiece: null,
    setHeldPiece: (color) => set({ heldPiece: color }),
    clearHeldPiece: () => set({ heldPiece: null }),

    nextPieces: [],
    setNextPieces: (pieces) => set({ nextPieces: pieces }),
    pushPopNextPiece: (color) =>
      set((state) => {
        const newNextPieces = [...state.nextPieces];
        newNextPieces.shift();
        newNextPieces.push(color);
        return { nextPieces: newNextPieces };
      }),

    score: 0,
    incrementScore: (x) => set((state) => ({ score: state.score + x })),
    clearScore: () => set({ score: 0 }),

    linesCleared: 0,
    incrementLinesCleared: (x) =>
      set((state) => ({ linesCleared: state.linesCleared + x })),
    clearLinesCleared: () => set({ linesCleared: 0 }),
    decrementLinesCleared: (x) =>
      set((state) => ({ linesCleared: state.linesCleared - x })),

    level: 1,
    incrementLevel: () => set((state) => ({ level: state.level + 1 })),
    clearLevel: () => set({ level: 1 }),

    paused: false,
    setPaused: (paused) => set({ paused }),
    togglePaused: () =>
      set((state) => {
        return { paused: !state.paused };
      }),

    timer: INITIAL_TIMER,
    decrementTimer: () => set((state) => ({ timer: state.timer - 1 })),
    clearTimer: () => set({ timer: INITIAL_TIMER }),

    startedOnce: false,
    setStartedOnce: () => set({ startedOnce: true }),
  }))
);
